import { definePreset } from '@primeng/themes'
import Aura from '@primeng/themes/aura'

export const PrimeNgCustomPreset = definePreset(Aura, {
  semantic: {},
  components: {
    // Note: PrimeNG 20 removed 'padding' from TreeDesignTokens
    // If tree padding customization is needed, use CSS instead
  },
})
